export default __webpack_public_path__ + "static/media/Img4.4cdd1be9.jpg";